import React from 'react';
import { Result, Button } from 'antd';
import graylogService from 'services/GraylogService';

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null, errorInfo: null };
    }

    static getDerivedStateFromError(error) {
        // Update state so the next render will show the fallback UI
        return { hasError: true };
    }

    componentDidCatch(error, errorInfo) {
        // Log error to Graylog
        this.setState({
            error: error,
            errorInfo: errorInfo
        });

        // Send error to Graylog
        graylogService.logPageCrash(error, errorInfo);

        // Also log to console for development
        console.error('ErrorBoundary caught an error:', error, errorInfo);
    }

    handleReload = () => {
        window.location.reload();
    };

    handleGoHome = () => {
        window.location.href = '/app';
    };

    render() {
        if (this.state.hasError) {
            // You can render any custom fallback UI
            return (
                <div style={{
                    minHeight: '100vh',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    padding: '20px'
                }}>
                    <Result
                        status="error"
                        title="Something went wrong"
                        subTitle="The application encountered an unexpected error. Our team has been notified."
                        extra={[
                            <Button type="primary" key="reload" onClick={this.handleReload}>
                                Reload Page
                            </Button>,
                            <Button key="home" onClick={this.handleGoHome}>
                                Go to Home
                            </Button>,
                        ]}
                    />
                </div>
            );
        }

        return this.props.children;
    }
}

export default ErrorBoundary;
